import { useEffect, useState } from "react";
import type { Props } from "../../../types/props";
import { getParsedButtonClassName } from "./helpers";
import "./style.css";
import Preloader from './preloader';

type ButtonProps = Props<{
  appearance?: "primary" | "alt" | "secondary" | "tertiary" | "transparent";
  size?: "large" | "small";
  disabled?: boolean;
  loading?: boolean;
  notification?: string;
  onClick: () => void;
  onDisable?: () => void;
}>;


export const Button = (props: ButtonProps) => {
  const [showNotification, setShowNotification] = useState<boolean>(false);

  const handleClick = () => {
    if (props.notification) {
      setShowNotification(true);
      props.onClick();
    } else {
      props.onClick();
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (showNotification) setShowNotification(false)
    }, 2500);
  
    return () => clearTimeout(timeout)
  }, [showNotification])
  
  return (
    <button
      id={props.id}
      key={props.key}
      className={getParsedButtonClassName(props.appearance, props.className, props.disabled, props.size)}
      style={props.style}
      onClick={() => {
        if (props.disabled) {
          props.onDisable?.();
        } else {
          handleClick()
        }
      }}
    >
      {props.loading ? <Preloader/> : props.children}
      {props.notification ? (
        <div className={`button--notification${showNotification ? " show" : ""}`}>{props.notification}</div>
      ) : null}
    </button>
  );
}